import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/BlombosLogo.svg';
import { userForgotPassword } from '../../api/loginApi';
import { validateEmail } from '../../utils/common';
import { toast } from 'sonner';
const ForgotPassword = (props) => {
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState('');
  const [email, setEmail] = useState('');
  const handleuserForgotPassword = async () => {
    if (!validateEmail(email)) {
      setEmailError('Invalid email address');
      return;
    }
    setEmailError('');
    toast.promise(userForgotPassword(email), {
      loading: 'Sending OTP in...',
      success: (data) => {
        navigate('/resetPassword', { state: { email: email } });
      },
      error: (err) => {
        console.log(err);
        return 'Invalid email or password';
      },
      duration: 800,
    });
  };

  const handleEmailChange = (event) => {
    const email = event.target.value;
    setEmail(email);
    if (!validateEmail(email)) {
      setEmailError('Invalid email address');
      return;
    } else {
      setEmailError('');
    }
  };
  return (
    <div className="theme-cyan">
      <div>
        <div className="vertical-align-wrap">
          <div className="vertical-align-middle auth-main">
            <div className="auth-box">
              <div className="top">
                <img src={Logo} alt="Blombos" style={{ width: '300px' }} />
              </div>
              <div className="card">
                <div className="header">
                  <p className="lead">Recover my password</p>
                </div>
                <div className="body">
                  <p>
                    Please enter your email address below to receive
                    instructions for resetting password.
                  </p>
                  <div className="form-auth-small ng-untouched ng-pristine ng-valid">
                    <div className="form-group">
                      <input
                        className="form-control"
                        placeholder="Email"
                        type="text"
                        value={email}
                        onChange={handleEmailChange}
                      />
                      {emailError && (
                        <div className="error-message" style={{ color: 'red' }}>
                          {emailError}
                        </div>
                      )}
                    </div>
                    <button
                      className="btn btn-primary btn-lg btn-block"
                      type="submit"
                      onClick={handleuserForgotPassword}
                    >
                      RESET PASSWORD
                    </button>
                    <div className="bottom">
                      <span className="helper-text">
                        Know your password? <a href="login">Login</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(ForgotPassword);
